import { Component } from '@angular/core';

@Component({
  selector: 'app-reporting-disclaimer',
  templateUrl: './reporting-disclaimer.component.html',
  styleUrls: ['./reporting-disclaimer.component.scss'],
  standalone: false
})
export class ReportingDisclaimerComponent {}
